// extracted by mini-css-extract-plugin
export default {"IconWrapper":"FavouriteBadge_IconWrapper__BmlIL","IconWrapper__Icon":"FavouriteBadge_IconWrapper__Icon__YsVou"};